const TURBO_STREAM = "text/vnd.turbo-stream.html";

export function isTurboStream(contentType) {
  return (contentType || "").startsWith(TURBO_STREAM);
}

// The result screen is the only answer that replaces the sending screen in
// place. Every failure finalize reports is a toast stream, and some of those
// carry a 2xx (a capture whose outcome is unknown answers 202), so the status
// alone cannot tell the two apart.
export function withdrawalFailed({ succeeded, contentType }) {
  return !succeeded || isTurboStream(contentType);
}
